import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Forex Brokers Association | Official FBA Awards & Global Standards",
  description = "Forex Brokers Association (FBA) - Promoting integrity, transparency, and ethical practices in foreign exchange trading. Discover award-winning brokers and FX Global Code standards.",
  keywords = "forex brokers, FBA, forex trading, best forex brokers, forex awards, FX global code, forex association, trading ethics, forex regulation",
  ogImage = "https://customer-assets.emergentagent.com/job_winners-pro/artifacts/wuxtjwav_FBA-02.png",
  url = "https://forexbrokersassociation.com/"
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={url} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;